import $store from '@/store';

export const showLoader = (): void => {
    $store.commit('showLoader');
};

export const hideLoader = (): void => {
    $store.commit('hideLoader');
};
